import { render, staticRenderFns } from "./headerNav.vue?vue&type=template&id=5821edb4&"
import script from "./headerNav.vue?vue&type=script&lang=js&"
export * from "./headerNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports